import React from 'react'

function Topics() {
  return (
    <div>
      topics
    </div>
  )
}

export default Topics
